import AccountService from '@/services/AccountService';
export default {
  name: 'Info',
  props: {
    discount: {
      type: Object,
      default: null
    },
    subscriptiontype_id: Number,
    balance: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      default: 'default'
    }
  },
  data: () => {
    return {
      code: null,
      codeValid: true,
      codeErrorMessage: null,
      searchCode: false
    };
  },
  methods: {
    checkCode() {
      if (this.searchCode || !this.code || !this.code.length) {
        return false;
      }
      this.searchCode = true;
      AccountService.checkCode(this.code, this.subscriptiontype_id, +this.balance).then(response => {
        // this.discount = response.data
        this.codeValid = true;
        this.$emit('discountApplied', response.data);
      }).catch(err => {
        this.codeValid = false;
        this.codeErrorMessage = err.response.data.error[0];
      }).finally(() => {
        this.searchCode = false;
      });
    },
    clearDiscount() {
      this.codeValid = false;
      this.$emit('discountApplied', {});
    }
  }
};